export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-badge/index.js